import { IdsAvailableType, isIdsAvailableType } from '@idConnect/types';
import { consoleLogger } from '@shared/logging/consoleLogger';
import { IframeEventType, isIframeEventType } from '@utiqLoader/types';
import { addEventListener } from '@shared/api/sharedAPIEventFunctions';

export const setIframeEventHandler = () => {
  const mountUtiqLocatorIFrame = () => {
    const utiqLocatorIframe = document.createElement('iframe');
    utiqLocatorIframe.setAttribute('id', '__utiqLocator');
    utiqLocatorIframe.setAttribute('name', '__utiqLocator');
    utiqLocatorIframe.setAttribute('hidden', 'true');
    document.body.appendChild(utiqLocatorIframe);
  };
  if (window.document.readyState !== 'loading') {
    mountUtiqLocatorIFrame();
  } else {
    document.addEventListener('DOMContentLoaded', mountUtiqLocatorIFrame);
  }

  const sendIds = (
    idsAvailable: IdsAvailableType,
    iframeEvent: IframeEventType,
  ) => {
    consoleLogger.logDebug('Sending available IDs to __receiverIframe');
    const { atid, mtid: mtidValue } = idsAvailable;
    const isExcludePolicy =
      window.Utiq?.config?.integrations?.iframeMtidExclude;
    const isOriginIncluded =
      window.Utiq?.config?.integrations?.iframeMtidDomains?.some(
        (domain: string) => iframeEvent.origin.includes(domain),
      );
    const shouldSendMTIDValue =
      (isExcludePolicy && !isOriginIncluded) ||
      (!isExcludePolicy && isOriginIncluded) ||
      window.origin === iframeEvent.origin;

    iframeEvent.source.postMessage(
      {
        action: 'returnIdGraphEntry',
        description: iframeEvent.data?.description,
        idGraphData: {
          atid,
          mtid: shouldSendMTIDValue ? mtidValue : null,
        },
      },
      iframeEvent.origin as WindowPostMessageOptions,
    );
  };

  const sendPostMessage = (iframeEvent: unknown) => {
    if (!isIframeEventType(iframeEvent)) return;

    if (window.Utiq?.API?.getUtiqConsentStatus?.() === false) {
      iframeEvent.source.postMessage(
        {
          action: 'returnIdGraphEntry',
          description: iframeEvent.data?.description,
          idGraphData: undefined,
        },
        iframeEvent.origin as WindowPostMessageOptions,
      );
    } else {
      window.Utiq?.API?.addEventListener?.('onIdsAvailable', (idsAvailable) =>
        isIdsAvailableType(idsAvailable)
          ? sendIds(idsAvailable, iframeEvent)
          : null,
      );
    }
  };

  window.addEventListener(
    'message',
    (event: MessageEvent<{ action: string }>) => {
      if (event.data?.action === 'getIdGraphEntry') {
        if (window.Utiq?.API?.getUtiqConsentStatus?.() !== undefined) {
          sendPostMessage(event);
        }
        addEventListener('onConsentUpdateFinished', () =>
          sendPostMessage(event),
        );
      }
    },
  );
};
